import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { ShareFileModalComponent } from 'src/app/folder/share-file-modal/share-file-modal.component';
import { MatDialog, MatSnackBar, MatTabGroup, throwMatDialogContentAlreadyAttachedError, throwMatDuplicatedDrawerError } from '@angular/material';
import { DeleteConfirmModalComponent } from '../delete-confirm-modal/delete-confirm-modal.component';
import { FolderService } from '../../services/folder.service';
import { FileService } from 'src/app/services/file.service';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { FilterService } from '../../services/filter.service';
import * as  JSZip from 'jszip';
import * as JSZipUtil from 'jszip-utils'
import { saveAs } from "file-saver";
import * as _ from 'lodash';
import { CompetenciesService } from 'src/app/services/competencies.service';
JSZip.support.nodebuffer = false;
import { ActivatedRoute, Router } from '@angular/router';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { AccidentService } from '../../services/accident.service'
import { config } from '../../_models/userCompetency'
import { competencyTypes } from '../../_models/staticArray'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';


@Component({
  selector: 'app-file-details',
  templateUrl: './file-details.component.html',
  styleUrls: ['./file-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileDetailsComponent implements OnInit {
  @Input('details') recievedFile;
  @Input('isComp') isCompet;
  @Input('instructorUserName') instructorUserName
  @Input('isCompetency') isCompetency;
  @Input('matrialObject') matrialObject;
  @Input('competencieId') competencieId;
  @Output() fileDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() titleChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() compAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() compDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletedFiles: EventEmitter<any> = new EventEmitter<any>();
  @Output() deletedFile: EventEmitter<any> = new EventEmitter<any>();
  @Output() submissionDeletedFiles: EventEmitter<any> = new EventEmitter<any>();
  @Output() markAsReadFile: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;

  // public bankFilterCtrl: FormControl = new FormControl();
  bankFilterCtrl

  createdAt: any;
  totalFiles: any;
  lastUpdate: any;
  title: any;
  isComp: boolean = false;
  displaySaveBtn: boolean = false;
  id: any;
  value: boolean = false
  units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  supportedDocuments = ['doc', 'docx', 'pdf', 'ppt', 'pptx', 'xlsx', 'xls'];
  fileExtensionArray = ['ppt', 'zip', 'pptx', 'mp4', 'xls', 'xlsx', 'txt', 'odt', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'];

  category = config.list
  categoryTitle = []
  categoryTitleCopy = []
  competencesType = competencyTypes;
  instructorName
  loading: boolean = false;
  loading2: boolean = false;
  competencesFiles = [];
  currentFolder;
  currentFolder2;
  sharedClient = [];
  sharedInstructor = [];
  // isMaterials: boolean;
  fileType;
  path: any;
  readOnlyTitle: boolean = true;
  supportedDocument: boolean;
  type: any;
  currentUser: any;
  user;
  hideActions: boolean = false;
  pathForPreview: string;
  comp: any;
  selectedIndex;
  titleCopy: any;
  hide: boolean;
  isMyDocs = false;
  isMaterial: boolean = false;
  error: string;
  currentProgress: any;
  showCurrentProgress: boolean;
  downloadDisable: boolean = false;
  isReadingMaterial = false;
  markInstsRead = [];
  markclientRead = [];
  showMarkCheckBoxes: boolean;
  isDeleteForLearner: boolean;
  sharedInstructorCopy: any[];
  sharedClientCopy: any[];
  isLoading = false
  fileId: any;
  imageThumbnail: any;
  fileExtension: any;
  isLoading1 = false
  fileDetailForm: FormGroup
  hideField: boolean = true
  isExpiry: boolean = true
  dateisValid: boolean = false;
  isNewTabImage: boolean = false
  isEviFile: boolean = false
  userDocuments: boolean = false
  alias: any;
  isAssessementDisplay
  expiryDate
  achievementDate
  competenciesType
  competenciesSaveBtn: boolean = true
  bookedDate
  isReset: boolean = false;
  isSubmit: boolean = false;
  filename: any;
  userRole: any;
  isAdmin: boolean = false
  isShare = false
  isPreview = false
  constructor(
    public _folderService: FolderService,
    public _fileService: FileService,
    public _competencyService: CompetenciesService,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    public router: Router,
    public _accidentService: AccidentService,
    private formBuilder: FormBuilder,
    public _portfolioService: PortfolioService,
    private elRef: ElementRef,
    public _filter: FilterService,
    private activatedRoute: ActivatedRoute
  ) {

  }

  ngOnInit() {
    console.log("config config config", this.userRole);
    console.log("On init isCompetency", this.isCompet);
    console.log(this.recievedFile)
    console.log("this.recievedFile in file-details", this.recievedFile);
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    console.log("current user data ====>", this.currentUser)

    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.user && (this.user.isClient || this.user.isTrainer || this.user.isMp)) {
      this.hideActions = true
    }
    if (this.user && (this.user.isLearner)) {
      this.isDeleteForLearner = false;
    }
    if (this.user && (this.user.isAdmin)) {
      this.isAdmin = true;
    }

    if (this.user) {
      this.hide = this.user.isClient ? true : false
    }

    // if (this.router.url.includes('/labour-job/view')) this.isShare = true
    // else this.isShare = false
    this.createForm();


  }
  ngOnChanges(changes: SimpleChanges): void {
    this.isMaterial = false
    this.isMyDocs = false

    // this.cd.detectChanges()
    console.log("On init File details data", changes);
    console.log("CALL THIS PART OR NOT", this.router.url, this.router.url.includes('/labour-job/view'));
    if (this.router.url.includes('/labour-job/view')) this.isShare = true
    else this.isShare = false
    if (this.router.url.includes('/mydocuments') || this.router.url.includes('labour-job') || this.router.url.includes('client/view')) {
      console.log("isMyDocs=>", this.isMyDocs)
      this.isMyDocs = true;
    }
    else if (this.router.url.includes('/materials') || this.router.url.includes('/jobs')) {
      this.isMaterial = true;
    }
    else if (this.router.url.includes('/learnerReadingMaterial')) {
      this.isReadingMaterial = true;
      this.isMaterial = false;
    }

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    if (this.user && (this.user.isClient || this.user.isTrainer || this.user.isMp)) {
      this.hideActions = true
    }
    this.displaySaveBtn = false
    console.log("CHANGES", changes);

    if (changes.isCompet && changes.isCompet.currentValue) {
      console.log("changes.isCompet.currentValue", changes.isCompet.currentValue);
      this.isCompet = changes.isCompet.currentValue
      console.log("this.isCompt", this.isCompet);
      this.competenciesType = "competencies"
      // this.error=""
    }

    if (changes.recievedFile && changes.recievedFile.currentValue && changes.recievedFile.currentValue.isCompetencies == true) {
      this.competenciesType = 'competencies'
      this.isComp = true;
      this.error = ""
      this.comp = changes.recievedFile.currentValue;
      this.displaySaveBtn = true
      this.comp.competenciesType && this.comp.competenciesType.length && this.comp.competenciesType[this.comp.competenciesType.length - 1].type == 'intriem' ? this.isAssessementDisplay = false : this.isAssessementDisplay = true

      if (this.isAssessementDisplay == false) {
        this.comp.trainingStartDate = ''
        this.comp.trainingEndDate = ''
      }
      console.log("this.comp..................", this.comp);

      this.createForm(this.comp)

      let element = this.category.find((x) => x.viewValue === this.comp.category)
      console.log("this is last element to be select", element);
      if (element != undefined) {
        this.categoryTitle = element.value
        this.categoryTitleCopy = element.value
      }
      this.hideField = false
      this.competencesFiles = this.comp.files;
      this.competencieId = changes.recievedFile.currentValue._id
      console.log('This.comp====>', this.comp)

    }

    if (changes.isCompetency && changes.isCompetency.currentValue == true) {
      this.isCompetency = changes.isCompetency.currentValue;

    }
    if (changes.competencieId && changes.competencieId.currentValue) {
      this.competencieId = changes.competencieId.currentValue
    }


    if (changes.matrialObject && changes.matrialObject.currentValue) {
      console.log("materialObject value", changes.matrialObject.currentValue.event.name)
      this.filename = changes.matrialObject.currentValue.event.name
      // let regex = new RegExp('[^.]+$');
      // let tempFile = changes.recievedFile.currentValue.path.match(regex)
      // console.log("file name temp get etension", tempFile[0]);
      // this.filename.concat('.',tempFile[0])
    }

    if (changes.recievedFile && changes.recievedFile.currentValue) {
      console.log("changes.recievedFile.currentValue ==> ", changes.recievedFile.currentValue, this.isPreview)
      this.fileId = changes.recievedFile.currentValue._id
      this.imageThumbnail = changes.recievedFile.currentValue.thumbNail;
      this.isLoading = true;

      this.fileExtension = changes.recievedFile.currentValue.extension;
      this.currentFolder = changes.recievedFile.currentValue;
      this.isPreview = false
      this.cd.detectChanges();

      // TITLE
      (changes.recievedFile.currentValue.alias) ? this.title = changes.recievedFile.currentValue.alias : this.title = changes.recievedFile.currentValue.title
      if (this.title) { this.titleCopy = this.title }


      // TYPE
      this.fileType = changes.recievedFile.currentValue.type;
      if (changes.recievedFile.currentValue.uploadedBy == this.currentUser.name && this.user.isLearner) {
        this.isDeleteForLearner = true;
      }
      else {
        this.isDeleteForLearner = false;
      }

      if (changes.recievedFile.currentValue.type == 'material') this.isMaterial = true; else this.isMaterial = false
      if (changes.recievedFile.currentValue.type == 'evidence' || changes.recievedFile.currentValue.type == 'cpd' || changes.recievedFile.currentValue.type == 'competencies') this.isEviFile = true; else this.isEviFile = false

      if (changes.recievedFile.currentValue.type == 'folder') this.readOnlyTitle = false; else this.readOnlyTitle = true;
      this.type = changes.recievedFile.currentValue.type;

      if (changes.recievedFile.currentValue.type == 'file') this.isMyDocs = true

      if (changes.recievedFile.currentValue.type == 'userDocument' || changes.recievedFile.currentValue.type === 'fixedAsset' || changes.recievedFile.currentValue.type == 'asset') this.userDocuments = true

      this.type = changes.recievedFile.currentValue.type;
      // DATES
      this.createdAt = changes.recievedFile.currentValue.createdAt;

      // PATH
      if (changes.recievedFile && changes.recievedFile.currentValue) {

        this.path = ""
        this.path = changes.recievedFile.currentValue.path || changes.recievedFile.currentValue.Location;
        // this.displayData = this.sanitizer.bypassSecurityTrustHtml(this.discussionDetails.content);

        const player = this.elRef.nativeElement.querySelector('video');
        console.log("player selected", player);
        if (player != null) {
          player.load();
        }
        if (this.fileExtension == 'avi' || this.fileExtension == 'vob') {
          console.log("change file size=========", changes.recievedFile.currentValue.path);
          console.log("or this is already assign=====", this.path);
        }

      }
      this.supportedDocument = this.supportFilePreview(changes.recievedFile.currentValue.extension);


      // ID
      this.id = changes.recievedFile.currentValue._id;

      // SHARED WITH sharedClient
      if (changes.recievedFile.currentValue.sharedClient != undefined) {
        if (changes.recievedFile.currentValue.sharedDoc) {
          this.sharedClient = changes.recievedFile.currentValue.sharedDoc.sharedClient;
          this.sharedClientCopy = this.sharedClient
        }
        else {
          this.sharedClient = changes.recievedFile.currentValue.sharedClient;
        }
      }

      // SHARED WITH sharedInstructor
      if (changes.recievedFile.currentValue.sharedInstructor != undefined) {
        if (changes.recievedFile.currentValue.sharedDoc) {
          this.sharedInstructor = changes.recievedFile.currentValue.sharedDoc.sharedTrainer;
          this.sharedInstructorCopy = this.sharedInstructor
        }
        else {
          this.sharedInstructor = changes.recievedFile.currentValue.sharedInstructor;
        }
        console.log('this.sharedInstructor=======>', this.sharedClient);
      }


      this.userRole = this.currentFolder.role
      setTimeout(() => {
        this.isPreview = true
        this.cd.detectChanges()
      }, 3000);

    }
    let url = this.router.url.split('=')
    if (url.includes('userRole') && url.includes('0')) this.userRole = '0'
  }


  createForm(data?) {

    console.log("data in createForm--->", this.type);

    if (data && data._id) {
      this.isReset = false
      this.achievementDate = data.achievementDate
      this.expiryDate = data.expiryDate
      this.bookedDate = data.bookedDate
    }
    else {
      this.isReset = true
    }

    this.fileDetailForm = this.formBuilder.group({
      type: new FormControl((data && data.competenciesType) ? data.competenciesType[data.competenciesType.length - 1].type : '', Validators.required),
      category: new FormControl((data && data.category) ? data.category : '', Validators.required),
      title: new FormControl((data && data.title) ? data.title : '', Validators.required),
      achievementDate: new FormControl((data && data.achievementDate) ? data.achievementDate : ''),
      expiryDate: new FormControl((data && data.expiryDate) ? data.expiryDate : ''),
      trainingStartDate: new FormControl((data && data.trainingStartDate) ? data.trainingStartDate : ''),
      trainingEndDate: new FormControl((data && data.trainingEndDate) ? data.trainingEndDate : ''),
      trainingBook: new FormControl((data && data.trainingBook) ? data.trainingBook : ''),
      assessmentComplete: new FormControl(''),
      bookedBy: new FormControl((data && data.bookedBy) ? data.bookedBy : ''),
      bookedDate: new FormControl((data && data.bookedDate) ? data.bookedDate : ''),
    })
    if (this.fileDetailForm.value.category != 'others') {
      this.achievementDate = Validators.required
      this.expiryDate = Validators.required
    }
  }

  showSaveBtn() {
    if (this.type == 'folder') this.displaySaveBtn = true; else this.displaySaveBtn = false;
  }
  // dateSelected(event) {
  //   console.log("event--->", event)
  //   this.comp.expiryDate = event
  // }

  shareWith() {
    console.log("ShareWith");
    console.log("this.recievedFiles", this.recievedFile);
    this.openDialog(ShareFileModalComponent, { data: this.recievedFile, inst: this.sharedInstructor, client: this.sharedClient, isShare: true }).subscribe(users => {
      if (users == undefined) return
      console.log('users here==>', users);
      this.sharedClient = []
      this.sharedInstructor = [];
      this.selectedIndex = 0;

      this._folderService.getSharingDetail(users.file._id).subscribe(res => {
        console.log('Success===', res);
        this.sharedClient = res.response.sharedClient
        this.sharedClientCopy = res.response.sharedClient
        this.sharedInstructor = res.response.sharedTrainer
        console.log("total shared client data", this.sharedClient);

        this.cd.detectChanges();
        this.openSnackBar("Shared successfully!", "ok")
      })
    })
  }
  instSelected(event, inst) {
    console.log(event, inst)
    if (event.checked == true) {
      let index = _.findIndex(this.markInstsRead, function (o) { return o.instId == inst._id._id })
      if (index == -1) {
        this.markInstsRead.push({ instId: inst._id._id })
      }
      console.log('this.markInstsRead', this.markInstsRead)
    }
    else {
      let index = _.findIndex(this.markInstsRead, function (o) { return o.instId == inst._id._id })
      if (index > -1) {
        this.markInstsRead.splice(index, 1)
      }
    }
  }
  instDateChanged(value, inst, i, type) {
    console.log("EVENT for instructor date check here###", value, inst, i, type)
    if (this.markInstsRead && this.markInstsRead.length) {
      console.log('IN IF', this.markInstsRead);
      let index = _.findIndex(this.markInstsRead, function (o) { return o.instId == inst._id._id })
      if (index > -1) {
        console.log("MATCH FOUND");

        if (type == 'shared') {
          this.markInstsRead[index]['sharedAt'] = value
        }
        else {
          this.markInstsRead[index]['readAt'] = value
        }
        console.log("this.markInstsReadthis.markInstsRead", this.markInstsRead)
      }
      else {
        this.sharedInstructor[i]['checked'] = "true"
        console.log('this.sharedInstructor', this.sharedInstructor)
        if (type == 'shared') {
          this.markInstsRead.push({ instId: inst._id._id, sharedAt: value })
        }
        else {
          this.markInstsRead.push({ instId: inst._id._id, readAt: value })
        }
      }
    }
    else {
      console.log("MATCH NOT FOUND");
      this.sharedInstructor[i]['checked'] = "true"
      console.log('this.sharedInstructor', this.sharedInstructor)
      if (type == 'shared') {
        this.markInstsRead.push({ instId: inst._id._id, sharedAt: value })
      }
      else {
        this.markInstsRead.push({ instId: inst._id._id, readAt: value })
      }
    }
  }
  // instSDateChanged(event, inst, i){

  // }
  editInstructor(value) {
    console.log("value was here !!", value)
    return value
  }

  clientSelected(event, client) {
    console.log(event, client)
    if (event.checked == true) {
      let index = _.findIndex(this.markclientRead, function (o) { return o.clientId == client._id._id })
      if (index == -1) {
        this.markclientRead.push({ clientId: client._id._id })
      }
    }
    else {
      let index = _.findIndex(this.markclientRead, function (o) { return o.clientId == client._id._id })
      if (index > -1) {
        this.markclientRead.splice(index, 1)
      }
    }
  }
  clientDateChanged(value, client, i, type) {
    console.log("EVENT", value)

    // console.log("client add verfiy and update !!!!",this.sharedClient[i]);
    // let objsharedClient= this.sharedClient[i];


    if (this.markclientRead && this.markclientRead.length) {
      let index = _.findIndex(this.markclientRead, function (o) { return o.clientId == client._id._id })
      if (index > -1) {
        if (type == 'shared') {
          this.markclientRead[index]['sharedAt'] = value

        }
        else {
          this.markclientRead[index]['readAt'] = value
        }
        console.log("this.markInstsReadthis.markInstsRead", this.markclientRead)
      }
      else {
        this.sharedClient[i]['checked'] = "true"
        console.log('this.sharedClient', this.sharedClient)
        if (type == 'shared') {
          this.markclientRead.push({ clientId: client._id._id, sharedAt: value })
        }
        else {
          this.markclientRead.push({ clientId: client._id._id, readAt: value })
        }
      }
    }
    else {
      this.sharedClient[i]['checked'] = "true"
      console.log('this.sharedClient', this.sharedClient)
      if (type == 'shared') {
        this.markclientRead.push({ clientId: client._id._id, sharedAt: value })
      }
      else {
        this.markclientRead.push({ clientId: client._id._id, readAt: value })
      }
    }
  }
  mark() {
    this.showMarkCheckBoxes = true
    this.markInstsRead = [];
    this.markclientRead = [];
  }
  saveMarked() {
    this.showMarkCheckBoxes = false
    let obj = {
      document: this.id,
      sharedTrainer: this.markInstsRead,
      sharedClient: this.markclientRead
    }
    console.log("MARKED AND UNDERSTOOD", obj)
    this._folderService.markAsReadAdmin(obj).subscribe(res => {
      this._folderService.getSharingDetail(this.id).subscribe(res => {

        console.log('Success===', res);
        this.sharedClient = res.response.sharedClient
        this.sharedInstructor = res.response.sharedTrainer
        this.cd.detectChanges();
        this.openSnackBar("Marked as read", 'OK')

      })
    })

  }

  openDocument(element: HTMLElement) {
    console.log("THIS IS THE DOUCMENT", element);

  }
  cancle() {
    this.showMarkCheckBoxes = false;
    this.markInstsRead = [];
    this.markclientRead = [];
    this.sharedClient = [];
    this.sharedInstructor = [];
    console.log('this.sharedClient', this.sharedClient.length)
    console.log('this.sharedInstructor', this.sharedInstructor.length)
    this.sharedClient = JSON.parse(JSON.stringify(this.sharedClientCopy))
    this.sharedInstructor = JSON.parse(JSON.stringify(this.sharedInstructorCopy))
    this.sharedInstructor.forEach(el => {
      if (el.checked) {
        el.checked = false
      }
    })
    this.sharedClient.forEach(el => {
      if (el.checked) {
        el.checked = false
      }
    })
    // console.log('this.sharedInstructors', this.sharedInstructor, this.sharedInstructorCopy)
    this.cd.detectChanges();
    // this.picker1.select(undefined)
  }
  onTabChanged(event) {
    console.log("event", event)
    this.selectedIndex = event.index
  }
  openFolder() {
    this.router.navigate(['/mydocuments/single-folder', this.recievedFile._id])
  }
  // PR changes
  delete() {
    // this.loading = true
    let update = {
      title: this.title,
      id: this.id
    }
    let temp;
    console.log("temp====>>>>", this.type)

    console.log('File Delete Here:::', this.id);
    temp = (this.type === 'material') ? 'file' : this.type
    // temp = this.competenciesType == 'competencies' ? 'competency' : this.type
    console.log("temp====>>>>", temp)
    this.openDialog(DeleteConfirmModalComponent, temp).subscribe(confirm => {
      let sessionType = null;
      console.log("this.type in delete", this.type, this.matrialObject);
      // console.log(this.matrialObject.event.event.event , this.matrialObject.event.event.materialObject);
      if (this.matrialObject && this.matrialObject.event) {
        if (this.matrialObject.event.event) {
          if (this.matrialObject.event.event.event) {

            sessionType = this.matrialObject.event.event.event.materialObject.sessionType
          } else if (this.matrialObject.event.event.materialObject) {
            sessionType = this.matrialObject.event.event.materialObject.sessionType
          }

        }
      }
      console.log("Session tpye ====> ", sessionType)
      if (confirm == '') return
      else if (confirm == 'yes') {
        if (this.type == 'folder') {
          console.log("this.type == 'folder'");

          this._folderService.deleteFolder(this.id).subscribe(res => {
            console.log("res", res);
          })
        }
        else if (this.type == 'material' && !this.currentFolder.isSubmission) {
          console.log("this.type == 'material'", this.id);
          this._fileService.deleteFiles(this.id).subscribe(res => {
            console.log("MATERIAL DELETED", res);
            this.deletedFile.emit(this.id);
          }, (err) => {
            console.log("error in deleteing file ", err)
          })
        }
        else if (this.type == 'material' && this.currentFolder.isSubmission) {
          console.log("this.type == 'material'", this.id);
          this._fileService.deleteSubmissionFiles(this.id).subscribe(res => {
            console.log("MATERIAL DELETED", res);
            this.submissionDeletedFiles.emit({ fileId: this.id, type: 'material' })
          }, (err) => {
            console.log("error in deleteing file ", err)
          })
        }
        else if (this.type == 'file') {
          console.log("error in delete file")

          this._folderService.deleteFile(this.id).subscribe(res => {
            console.log("file DELETED", res);
          }, (err) => {
            console.log("error in delete file", err)
          })
        }
        else if (this.competenciesType == 'competencies') {
          console.log("competenciesId", this.competencieId, "fileId", this.id);
          this._competencyService.deleteCompetency(this.competencieId).subscribe(res => {
            console.log("Competency deleted", res);
            // this.closeFilesSideNav.emit('close')
            this.compDelete.emit({ competency: true })

          })
        } else if (this.type == 'material' && sessionType) {
          // PR CHANGES
          console.log("session file _ID  ===> ", this.id, this.fileType, this.matrialObject);
          this._portfolioService.deleteSessionFiles(this.id, sessionType).subscribe(res => {
            console.log("Session file deleted successfully ======> ", res);
          }, err => {
            console.log("error in deleting session file ======> ", err);
          });
          console.log("Console inside session type", this.id);
        }
        // this.loading = false

        //   console.log("line @438")
        this.fileDeleted.emit({ fileId: this.id, type: this.type, competenciesId: this.competencieId, recievedFile: this.recievedFile })
      }
    })
  }

  deleteSubmissionFile() {
    console.log("deleteSubmissionFile() function called");
    console.log('File Delete Here:::', this.id);

    let temp;
    temp = this.type == 'material' ? 'file' : this.type
    console.log("temp====>>>>", temp)

    this.openDialog(DeleteConfirmModalComponent, temp).subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this._fileService.deleteLearnerSubmissionFiles(this.id).subscribe(res => {
          console.log("DELETED FILE ----> ", res);
          if (res == undefined) return
          else {
            this.openSnackBar("File deleted successfully!", "Ok");
            this.deletedFiles.emit(res)
            this.closeFilesSideNav.emit('close')
          }
        }, (err) => {
          console.log("error in deleteing file ", err)
        })
      }
    })

  }

  downloadAll() {
    // zip.file(filename, result, { binary: true });
    // [14: 41]

    console.log('Download all calling', this.currentFolder);
    this.openSnackBar("Download will begin automatically", "OK");
    this.loading = true;
    this.downloadDisable = true;
    this._folderService.getFolderWithSubFolder(this.currentFolder._id).subscribe(folder => {
      console.log('Res in ts file===>>', folder);
      this.allFolderArray(folder).then((res) => {
        this.downloadDisable = false;
        if (this.currentFolder.status && this.currentFolder.status.isRead == false) {
          if (this.user && (this.user.isOperative || this.user.isClient)) {
            this._folderService.markAsRead([this.currentFolder._id]).subscribe(res => {
              console.log("RESPONSE OF MARK AS READ FILE", res);
              this.markAsReadFile.emit({ list: [this.currentFolder._id], type: 'folder' })
              // this.openSnackBar('Folder marked as read', 'OK')
            })
          }

        }
        this.cd.detectChanges();
        console.log('All Folder Completed', this.downloadDisable);
      }).catch((error) => {
        console.log('Error Here', error)
      })
    })
  }

  allFolderArray(folderArray) {
    console.log('allFolderArray', folderArray);
    let count = 0;
    return new Promise((resolve, reject) => {
      if (folderArray && folderArray.length) {
        folderArray.forEach(async folder => {
          const result = await this.makeZip(folder);
          console.log('Folder Complete==>', folder.title, count);
          count++;
          if (count == folderArray.length) {
            resolve()
          }
        })
      }
    })
  }

  makeZip(folder) {
    this.showCurrentProgress = true;
    console.log("this.showCurrentProgress===>", this.showCurrentProgress);
    let count = 0;
    let zip: any = new JSZip();
    let fileArray = folder.files;
    let percent = 100 / fileArray.length;
    let download = 0;
    this.currentFolder2 = folder.title;

    return new Promise((resolve, reject) => {
      if (folder && folder.files && folder.files.length) {
        fileArray.forEach(async file => {
          const result = await this.downloadOne(file)
          let filename = file.path.split("/")[3];
          download = download + percent;
          this.currentProgress = download;
          console.log("this.downloadProgress===>", this.currentProgress);
          zip.file(filename, result, { binary: true });
          count++;
          if (count == fileArray.length) {
            this.showCurrentProgress = false;
            console.log("this.showCurrentProgress===>", this.showCurrentProgress);
            zip.generateAsync({ type: 'blob' }).then((content) => {
              saveAs(content, folder.title);
              resolve()
            });
          }
        })
      } else {
        let msg = "No files contais in folder" + folder.title;
        this.showCurrentProgress = false;
        this.openSnackBar(msg, "ok")
        resolve();
      }
    })
  }


  downloadOne(file) {
    return new Promise((resolve, reject) => {
      JSZipUtil.getBinaryContent(file.path, {
        progress(e) {
          console.log("progress Event", e);
        }
      }).then((e) => {
        console.log('Download Complete', e);
        resolve(e)
      })
    })
  }


  saveFolder() {
    if (this.title == '' || this.title == null || this.title == undefined) {
      this.title = this.titleCopy
      this.openSnackBar("Title cannot be blank!", "ok")
    }
    else {
      let update = {
        title: this.title,
        id: this.id
      }
      console.log("UPDATE", update);
      this.recievedFile.title = this.title;
      this._folderService.editFolder(update).subscribe(res => {
        this.titleChanged.emit(this.recievedFile)
      })
      this.openSnackBar("Title updated successfully!", "ok")
    }
  }

  convertBytes(x) {
    let l = 0, n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + this.units[l]);
  }

  supportFilePreview(type) {
    console.log('File Type Support=====>>>>>>>', type);
    let index = _.findIndex(this.supportedDocuments, function (o) { return o == type; });
    if (index >= 0) {
      return true;
    } else {
      return false;
    }
  }

  openFileUpload(element, i) {
    if (this.fileDetailForm.value.category != 'others' && !this.fileDetailForm.value.achievementDate && !this.fileDetailForm.value.expiryDate) {
      this.dateisValid = false
      // this.isSubmit = true
      this.loading = false
    }
    else {

      if (this.comp && this.comp._id) {
        console.log('Update Calling', this.comp)
        if (this.fileDetailForm.value.title && this.fileDetailForm.value.category) {
          // let data = {
          //   title: this.comp.title,
          //   expiryDate: this.comp.expiryDate,
          //   competenciesId: this.comp._id,
          //   category: this.comp.category,
          //   achievementDate: this.comp.achievementDate,
          //   trainingBook: this.comp.trainingBook,
          //   bookedBy: this.comp.bookedBy,
          //   bookedDate: this.comp.bookedDate,
          //   alias: this.comp.alias,
          //   instructorId: this.comp.instructorId
          // }
          this.fileDetailForm.value['competenciesId'] = this.comp._id
          this.fileDetailForm.value['instructorId'] = this.comp.instructorId
          if (this.fileDetailForm.value.category == 'others')
            this.fileDetailForm.value['alias'] = "Other"
          else
            this.fileDetailForm.value['alias'] = this.alias

          let data = this.fileDetailForm.value
          this._competencyService.updateCompetency(data).subscribe(res => {
            console.log("response in edit competency Modal", res);
            // this.fileUpload(this.comp._id)
            let response = res.competencies
            this.fileUpload(this.comp._id).then((res) => {
              if (res) {
                response['files'] = res
                this.compAdded.emit({ competency: response, isEdit: true })
                this.closeFilesSideNav.emit('close')
                this.loading = false
              }
            })
          }, err => {
            console.log("err", err.msg)
            this.error = err.msg
            this.loading = false
          })
        }
        else {
          this.openSnackBar("Title and Category are required!", "OK");
        }
      } else {
        console.log('Add New Calling');
        if (this.fileDetailForm.value.title && this.fileDetailForm.value.category) {
          // let data = {
          //   title: this.comp.title,
          //   expiryDate: this.comp.expiryDate,
          //   competenciesId: this.comp._id,
          //   category: this.comp.category,
          //   achievementDate: this.comp.achievementDate,
          //   trainingBook: this.comp.trainingBook,
          //   bookedBy: this.comp.bookedBy,
          //   bookedDate: this.comp.bookedDate,
          //   alias: this.comp.alias,
          //   instructorId: this.comp.instructorId
          // }
          // this.fileDetailForm.value['competenciesId'] = this.comp._id
          this.fileDetailForm.value['instructorId'] = this.comp.instructorId

          if (this.fileDetailForm.value.category == 'others')
            this.fileDetailForm.value['alias'] = "Other"
          else
            this.fileDetailForm.value['alias'] = this.alias

          let data = this.fileDetailForm.value
          this._competencyService.addCompetency(data).subscribe(res => {
            console.log("response in edit competency Modal", res.competencies._id);
            let response = res.competencies
            this.fileUpload(res.competencies._id).then((res) => {
              if (res) {
                response['files'] = res
                this.compAdded.emit({ competency: response, isEdit: false })
                this.closeFilesSideNav.emit('close')
                this.loading = false
              }
            })
            // this.fileUpload(res.competencies._id)
            // this.compAdded.emit({ competency: res.competencies })
            // this.closeFilesSideNav.emit('close')
          }, err => {
            this.loading = false
            console.log("err", err.msg)
            this.error = err.msg

          })
        }
        else {
          this.openSnackBar("Title and Category are required!", "OK");

        }
      }
    }
  }

  selectCategory(event) {
    console.log("event when it is selected", event);
    console.log("details of com", this.comp);
    let element = this.category.find((x) => x.viewValue === event.value)
    console.log("this is last element to be select", element);
    if (element != undefined) {
      this.categoryTitle = element.value
      this.categoryTitleCopy = element.value
    }
    this.fileDetailForm.value.expiryDate = ''
    this.fileDetailForm.value.achievementDate = ''
    this.hideField = false

  }


  selectTitle(event) {
    console.log("event when title is selected", event);
    let title = this.fileDetailForm.value.title
    let element = this.categoryTitle.find((x) => x.name === title)
    if (element != undefined) {
      this.alias = element.alias
      // this.fileDetailForm.patchValue({ alias: element.alias })
    }
  }


  onKey(searchText) {
    console.log("event", searchText);
    // this.afterFilter = null
    // this.filterActive = true;
    this.categoryTitle = this.categoryTitleCopy
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      // this.filterActive = false;
      // this.updateData(this.jobs);
      this.categoryTitle = this.categoryTitleCopy
      return;
    }
    let data = this.categoryTitle
    let tempDataSource = this._filter.filter1(searchText, data, ['name', 'alias']);
    console.log("what is the temp data source", tempDataSource);
    if (tempDataSource && tempDataSource.length) this.categoryTitle = tempDataSource
    else this.categoryTitle = tempDataSource
  }

  // closePicker(event) {
  //   const date = this.fileDetailForm.value.achievementDate

  //   const element = this.categoryTitle.find((x) => x.name === this.fileDetailForm.value.title)
  //   console.log("this is element", element);
  //   const month = Number(element.validFor)

  //   const expiryDate = new Date(date.setMonth(date.getMonth() + month));
  //   const achievementDate = new Date(date.setMonth(date.getMonth() - month));
  //   this.fileDetailForm.patchValue({ achievementDate: achievementDate })
  //   this.fileDetailForm.patchValue({ expiryDate: expiryDate })
  //   // this.comp.achievementDate = achievementDate
  //   // this.comp.expiryDate = expiryDate

  // }

  onChangeEvent(event, formControl) {
    // if (this.fileDetailForm.value.category == '') {
    //   this.fileDetailForm.patchValue({ achievementDate: '' })
    //   this.fileDetailForm.patchValue({ expiryDate: '' })up
    // }
    this.dateisValid = true
    // this.isSubmit = false
    if (formControl == 'achievementDate') {
      const date = new Date(event)
      console.log("this.fileDetailForm.value.title--->", this.fileDetailForm.value.title)
      const element = this.categoryTitle.find((x) => x.name === this.fileDetailForm.value.title)
      console.log("this is element", element);
      const month = Number(element.validFor)
      this.expiryDate = new Date(date.setMonth(date.getMonth() + month));
      this.achievementDate = new Date(date.setMonth(date.getMonth() - month));
      this.expiryDate = ((this.expiryDate.getMonth() > 8) ? (this.expiryDate.getMonth() + 1) : ('0' + (this.expiryDate.getMonth() + 1))) + '/' + ((this.expiryDate.getDate() > 9) ? this.expiryDate.getDate() : ('0' + this.expiryDate.getDate())) + '/' + this.expiryDate.getFullYear()
      this.achievementDate = ((this.achievementDate.getMonth() > 8) ? (this.achievementDate.getMonth() + 1) : ('0' + (this.achievementDate.getMonth() + 1))) + '/' + ((this.achievementDate.getDate() > 9) ? this.achievementDate.getDate() : ('0' + this.achievementDate.getDate())) + '/' + this.achievementDate.getFullYear()
      this.fileDetailForm.patchValue({ achievementDate: this.achievementDate })
      this.fileDetailForm.patchValue({ expiryDate: this.expiryDate })
      this.competenciesSaveBtn = true
    }
    else if (formControl == 'bookedDate') {
      // this.bookedDate = new Date(event)
      this.fileDetailForm.patchValue({ bookedDate: event })
    }
  }

  onChangedEvent(event, formControl) {
    if (formControl == 'achievementDate' && this.fileDetailForm.value.type != 'probationary') {
      this.achievementDate = event
      this.fileDetailForm.patchValue({ achievementDate: this.achievementDate })
    }
    else if (formControl == 'expiryDate' && this.fileDetailForm.value.type != 'probationary') {
      this.expiryDate = event
      this.competenciesSaveBtn = true
      this.fileDetailForm.patchValue({ expiryDate: this.expiryDate })
    }

    if (formControl == 'achievementDate' && this.fileDetailForm.value.type == 'probationary') {
      // this.achievementDate = event
      this.fileDetailForm.patchValue({ trainingStartDate: event })
    }
    else if (formControl == 'expiryDate' && this.fileDetailForm.value.type == 'probationary') {
      // this.expiryDate = event
      this.competenciesSaveBtn = true
      this.fileDetailForm.patchValue({ trainingEndDate: event })
    }


  }

  trainingBooked(event) {
    console.log("event", event);

  }

  saveCompotencies() {
    console.log("saveCompotencies()--->", this.fileDetailForm.value);
    console.log("this.comp--->", this.comp);
    this.error = ""
    this.loading = true
    if (this.fileDetailForm.valid) {
      if (this.fileDetailForm.value.category != 'others' && !this.fileDetailForm.value.achievementDate && !this.fileDetailForm.value.expiryDate && !this.fileDetailForm.value.trainingStartDate && !this.fileDetailForm.value.trainingEndDate) {
        this.dateisValid = false
        this.isSubmit = false
        this.loading = false
      }
      else {
        if (this.comp && this.comp._id) {
          this.fileDetailForm.value['competenciesId'] = this.comp._id
          this.fileDetailForm.value['competenciesType'] = this.comp.competenciesType
          this.fileDetailForm.value['instructorId'] = this.comp.instructorId
          if (this.fileDetailForm.value.category == 'others')
            this.fileDetailForm.value['alias'] = "Other"
          else
            this.fileDetailForm.value['alias'] = this.alias

          let data = this.fileDetailForm.value
          console.log("this is data", data);
          this._competencyService.updateCompetency(data).subscribe(res => {
            console.log("response in edit competency Modal", res);
            console.log("response in edit competency Modal", res.competencies._id);
            this.compAdded.emit({ competency: res.competencies, isEdit: true })
            this.closeFilesSideNav.emit('close')
            this.loading = false
          }, err => {
            this.loading = false
            console.log("err", err.msg)
            this.error = err.msg
          })
        } else {
          this.fileDetailForm.value['instructorId'] = this.comp.instructorId
          if (this.fileDetailForm.value.category == 'others')
            this.fileDetailForm.value['alias'] = "Other"
          else
            this.fileDetailForm.value['alias'] = this.alias

          delete this.fileDetailForm.value.assessmentComplete


          let data = this.fileDetailForm.value
          // data['name']=this.instructorName
          console.log("this is data ===>", data);

          this._competencyService.addCompetency(data).subscribe(res => {

            console.log("what is the res of competency", res);

            if (res.competencies && res.competencies.msg) {
              this.loading = false
              this.error = res.competencies.msg
              this.cd.detectChanges()
              console.log("this is for already existis", res.competencies.msg, this.loading);
            } else {
              this.fileDetailForm.patchValue({ achievementDate: null })
              this.fileDetailForm.patchValue({ expiryDate: null })
              this.fileDetailForm.patchValue({ bookedDate: null })
              this.achievementDate = null
              this.expiryDate = null
              this.bookedDate = null
              console.log("response in edit competency Modal", res.competencies._id);
              res.competencies['competenciesId'] = res.competencies._id
              this.compAdded.emit({ competency: res.competencies, isEdit: false })
              this.closeFilesSideNav.emit('close')
              this.fileDetailForm.reset()
              this.loading = false
            }
          }, err => {
            console.log("err", err.msg)
            this.error = err.msg
            this.loading = false
          })
        }
      }
    } else {
      this.fileDetailForm.markAllAsTouched()
      this.loading = false
      this.isSubmit = true
    }
  }


  loadEvent(event) {
    console.log("WHEN DOCUMENT IS LOAD", event);

    this.isPreview = true
    // this.cd.detectChanges()
    // const element = $('#iframe')[0]
    // const iframe = document.getElementById("iframe") as HTMLIFrameElement;
    // // console.log("WHEN DOCUMENT IS LODEAD", element[0]);
    // const iWindow = iframe.contentWindow
    // const iDocument = iWindow.document;
    // console.log("THIS IS WE GOT FROM IFRAM", iWindow);

  }
  opennewtab() {
    console.log("CALL THIS OR NOT", this.recievedFile, this.user);
    if (this.fileExtension == 'ppt' || this.fileExtension == 'pptx' || this.fileExtension == 'doc' || this.fileExtension == 'docx' || this.fileExtension == 'xlsx' || this.fileExtension == 'xls' || this.fileExtension == 'dotx' || this.fileExtension == 'odt' || this.fileExtension == 'pdf' || this.fileExtension == 'txt' || this.fileExtension == 'potx' || this.fileExtension == 'rtf') {
      window.open(
        `https://docs.google.com/gview?url=${this.recievedFile.path}&embedded=true`, "_blank");
      if (this.user && (this.user.isOperative || this.user.isClient) && (this.recievedFile.status && this.recievedFile.status.isRead == false)) {
        this._folderService.markAsRead([this.recievedFile._id]).subscribe(res => {
          console.log("RESPONSE OF MARK AS READ FILE", res);
          this.markAsReadFile.emit({ list: [this.recievedFile._id], type: 'file' })
          // this.markAsReadFile.emit(res)
          // this.openSnackBar('Files marked as read', 'OK')
        })
      }
    } else if (this.fileExtension == 'mp4' || this.fileExtension == 'mov' || this.fileExtension == 'avi' || this.fileExtension == 'vob' || this.fileExtension == 'mp3') {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/video-preview/${this.recievedFile._id}`])
      );

      window.open(url, "_blank");
      if (this.user && (this.user.isOperative || this.user.isClient) && (this.recievedFile.status && this.recievedFile.status.isRead == false)) {
        this._folderService.markAsRead([this.recievedFile._id]).subscribe(res => {
          console.log("RESPONSE OF MARK AS READ FILE", res);
          this.markAsReadFile.emit({ list: [this.recievedFile._id], type: 'file' })
          // this.markAsReadFile.emit(res)
          // this.openSnackBar('Files marked as read', 'OK')
        })
      }
      // this.router.navigate([`/video-preview/${this.recievedFile._id}`])
    } else if (this.fileExtension == 'png' || this.fileExtension == 'jpg' || this.fileExtension == 'jpeg') {
      window.open(this.recievedFile.path, "_blank")
      if (this.user && (this.user.isOperative || this.user.isClient) && (this.recievedFile.status && this.recievedFile.status.isRead == false)) {
        this._folderService.markAsRead([this.recievedFile._id]).subscribe(res => {
          console.log("RESPONSE OF MARK AS READ FILE", res);
          // this.markAsReadFile.emit(res)
          this.markAsReadFile.emit({ list: [this.recievedFile._id], type: 'file' })
          // this.openSnackBar('Files marked as read', 'OK')
        })
      }
    }
  }

  // https%3A%2F%2Fdevelopment-platinum-rail-services.s3.eu-west-2.amazonaws.com%2Ffile_example_XLSX_50-1661508327357.xlsx
  // ndfHFb-c4YZDc-Wrql6b

  downloadClicked(path) {

    console.log("Current User Login", path, this.recievedFile);


    this.openSnackBar("Download will begin automatically", "OK");

    if (this.user && (this.user.isOperative || this.user.isClient)) {
      this._folderService.markAsRead([this.recievedFile._id]).subscribe(res => {
        console.log("RESPONSE OF MARK AS READ FILE", res);
        this.markAsReadFile.emit({ list: [this.recievedFile._id], type: 'file' })

        // this.markAsReadFile.emit(res)

        // this.getSharedFolders()
        // console.log('marked as read', res)
        // this.displayCheckBoxes = false;
        // this.openSnackBar('Files marked as read', 'OK')
      })
    }

    // let link = document.createElement("a");
    // link.download = 'name';
    // link.href = path;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // delete link;


    // const download: any = document.createElement("a")
    // const fileName = this.recievedFile.title
    // download.href = this.recievedFile.path
    // download.download = fileName
    // download.click()
    // setTimeout(() => {
    //   window.close()
    //   this.loading = false
    // }, 1000)
  }

  downloadWithName(event) {
    console.log("event while download file", event)
    console.log("file-name to be save in system", this.filename)
    console.log("file-path to be save in system", this.path)
    this.openSnackBar("Download will begin automatically", "OK");
    let tempName = this.filename + '_' + event.uploadedBy
    // let byteArray = new Uint8Array(event);
    // let blob = new Blob([byteArray], { type: event.extension });
    let title = ''
    title = tempName.concat('.', event.extension);
    console.log("title---->", title)
    saveAs(event.path, title);
  }

  fileUpload(competencieId) {
    return new Promise((resolve, reject) => {
      this.openDialog(NewFileModalComponent, { competenciesId: competencieId }).subscribe(uploaded => {
        console.log("uploaded", uploaded);
        this.comp.files.push(uploaded[0].data.file)
        resolve(this.comp.files)
      })
    })
  }

  FileExtension(extension) {
    let index = _.findIndex(this.fileExtensionArray, function (o) { return o == extension; });
    if (index >= 0) {
      return this.fileExtensionArray[index];
    } else {
      return 'default-extension';
    }
  }
  // Utility functions
  openDialog(someComponent, data: any = {}): Observable<any> {
    // data = this.recievedFile
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, panelClass: data.isShare ? 'share-model' : '' });
    return dialogRef.afterClosed();
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openImageInNewTab(imgUrl, extension) {
    this.isNewTabImage = true;
    this.isLoading1 = true;
    let fileContent = "image/" + extension;
    console.log(" ImageURL ", imgUrl)
    // this._http.get( imgUrl )
    fetch(imgUrl).then((response) => {
      this.isNewTabImage = false;
      return response.blob();
    }).then((blob) => {
      this.isLoading1 = false;
      this.cd.detectChanges();
      console.log(" myBlob ", blob)
      // let objectURL = URL.createObjectURL(myBlob);
      // console.log("objectURL", objectURL)
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
        let base64data = reader.result;
        console.log(base64data);
        const win = window.open("", "_blank");
        let html = '';
        html += '<html>';
        html += '<body style="margin:0!important">';
        html += '<embed width="100%" height="100%" src=' + base64data + ' type=' + fileContent + ' />';
        html += '</body>';
        html += '</html>';
        win.document.write(html);
      }
    });
  }

  assessmentCompleteChanges(event) {
    if (event.checked == true) {
      // this._accidentService.getSystemTime().subscribe((res) => {
      //   // this.dateNow = new Date(res.data.sytemTime);
      //   console.log("Here is Data ====>", res)
      //   const date = new Date(res.data.systemDate)
      //   const element = this.categoryTitle.find((x) => x.name === this.fileDetailForm.value.title)
      //   console.log("this is element", date);
      //   const month = Number(element.validFor)
      //   this.expiryDate = new Date(date.setMonth(date.getMonth() + month));
      //   this.achievementDate = new Date(date.setMonth(date.getMonth() - month));
      //   this.expiryDate = ((this.expiryDate.getMonth() > 8) ? (this.expiryDate.getMonth() + 1) : ('0' + (this.expiryDate.getMonth() + 1))) + '/' + ((this.expiryDate.getDate() > 9) ? this.expiryDate.getDate() : ('0' + this.expiryDate.getDate())) + '/' + this.expiryDate.getFullYear()
      //   this.achievementDate = ((this.achievementDate.getMonth() > 8) ? (this.achievementDate.getMonth() + 1) : ('0' + (this.achievementDate.getMonth() + 1))) + '/' + ((this.achievementDate.getDate() > 9) ? this.achievementDate.getDate() : ('0' + this.achievementDate.getDate())) + '/' + this.achievementDate.getFullYear()
      //   this.fileDetailForm.patchValue({ achievementDate: this.achievementDate })
      //   this.fileDetailForm.patchValue({ expiryDate: this.expiryDate })
      // }, (error) => {
      //   console.log("facing some issue get system date", error)
      // })
      this.fileDetailForm.patchValue({ achievementDate: '' })
      this.fileDetailForm.patchValue({ expiryDate: '' })
      this.competenciesSaveBtn = false
    }
    else {
      //   this.fileDetailForm.patchValue({ achievementDate: '' })
      //   this.fileDetailForm.patchValue({ expiryDate: '' })
      this.competenciesSaveBtn = true

    }
    this.cd.detectChanges()

  }


  /**
   * Download file or folder report
   */
  downloadReport() {
    this.loading2 = true
    console.log("hello here is the file report .....", this.recievedFile._id)
    // this._folderService.folderReadReportDownload(this.recievedFile._id).subscribe((data) => {
    console.log("hello here is the file report .....", this.recievedFile)
    // let document = {_id: this.recievedFile._id , type: this.recievedFile}
    this._folderService.folderReadReportDownload(this.recievedFile._id, this.recievedFile.type).subscribe((data) => {
      console.log("======byteArray =======", data)
      let byteArray = new Uint8Array(data.data);
      console.log("======byteArray =======", byteArray)
      let finalName = this.recievedFile.title.split(' ').join('_')
      let title = finalName + 'report' + '_' + moment(new Date).format("DD-MM-YYYY")
      this.loading2 = false
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(blob, title);
      this.cd.detectChanges()
      // saveAs(Blob, title)
      console.log("here is the reponse of report", data)
    }, (error) => {
      console.log("some error occure when download report here ===>", error)
      this.loading2 = false
      this.cd.detectChanges()
      console.log("some error occure when download report here ===>", error, this.loading2)
    })
  }



}
